import React from "react";
import styles from "./IndicatorVideoImage.module.css";
import AutoPlayMutedVideo from "./AutoPlayMutedVideo";
import { isImage } from "../util/Validator";
import ImageComponent from "./ImageComponent";
import clsx from "clsx";
import { AllCardsGames } from "../util/AllCardsGames";

interface IndicatorVideoImage {
  indicatorUrl: string;
  classNameStyle?: string;
  gameType?: AllCardsGames | null;
}

const IndicatorVideoImage: React.FC<IndicatorVideoImage> = ({
  indicatorUrl,
  classNameStyle,
}) => {
  const isImageUrl = isImage(indicatorUrl);

  return (
    <div
      className={clsx(
        styles["container"],
        isImageUrl && styles["image-container"],
        classNameStyle
      )}
    >
      {isImageUrl ? (
        <ImageComponent
          src={indicatorUrl}
          className={styles["container-view"]}
        />
      ) : (
        <AutoPlayMutedVideo
          videoSrc={indicatorUrl}
          classNameStyle={clsx(styles["container-view"])}
        />
      )}
    </div>
  );
};

export default IndicatorVideoImage;
